import './InvestorList.scss';
import Component from './InvestorList.js';
export default Component;
